export type FilterDrawerStorageKey = 'assetList_filterDrawerOpen' | 'systemList_filterDrawerOpen';

/** Reads the persisted filter drawer state, defaulting to open for new users. */
export const loadFilterDrawerOpen = (key: FilterDrawerStorageKey): boolean => {
    try {
        const stored = localStorage.getItem(key);
        return stored === null ? true : stored === 'true';
    } catch {
        return true;
    }
};

/** Persists the filter drawer open/closed state. */
export const saveFilterDrawerOpen = (key: FilterDrawerStorageKey, open: boolean): void => {
    try {
        localStorage.setItem(key, String(open));
    } catch {
        // ignore storage errors (e.g. private mode)
    }
};
